"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = exports.ErrorCodes = void 0;
var ErrorCodes;
(function (ErrorCodes) {
    // GENERIC ERRORS
    ErrorCodes["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    ErrorCodes["GOOGLE_PUBSUB_SEND_MESSAGE_ERROR"] = "GOOGLE_PUBSUB_SEND_MESSAGE_ERROR";
    ErrorCodes["GOOGLE_SECRET_MANAGER_ACCESS_SECRET_ERROR"] = "GOOGLE_SECRET_MANAGER_ACCESS_SECRET_ERROR";
    ErrorCodes["GOOGLE_SECRET_MANAGER_SET_SECRET_ERROR"] = "GOOGLE_SECRET_MANAGER_SET_SECRET_ERROR";
    ErrorCodes["GOOGLE_SECRET_MANAGER_DELETE_SECRET_ERROR"] = "GOOGLE_SECRET_MANAGER_DELETE_SECRET_ERROR";
    ErrorCodes["GRAPH_CYCLE_FOUND"] = "GRAPH_CICLE_FOUND";
    ErrorCodes["INVALID_COLUMN_TO_DELETE"] = "INVALID_COLUMN_TO_DELETE";
    ErrorCodes["REFERENCED_NODE_WITH_ERROR"] = "REFERENCED_NODE_WITH_ERROR";
    ErrorCodes["INVALID_RESULT_COLUMN_ID"] = "INVALID_RESULT_COLUMN_ID";
    ErrorCodes["INVALID_ROUNDING_OPTS_FOR_COLUMN"] = "INVALID_ROUNDING_OPTS_FOR_COLUMN";
    ErrorCodes["DOWNLOAD_FILE_NOT_FOUND"] = "DOWNLOAD_FILE_NOT_FOUND";
    ErrorCodes["NODE_NOT_FOUND"] = "NODE_NOT_FOUND";
    ErrorCodes["DUPLICATED_SOURCE_COLUMN"] = "DUPLICATED_SOURCE_COLUMN";
    ErrorCodes["TAB_LOCKED"] = "TAB_LOCKED";
    ErrorCodes["INVALID_INPUT"] = "INVALID_INPUT";
    ErrorCodes["NODE_TYPE_NOT_ALLOWED"] = "NODE_TYPE_NOT_ALLOWED";
    ErrorCodes["DISABLED_FOR_TABSOURCE_TYPE_MYSQL"] = "DISABLED_FOR_TABSOURCE_TYPE_MYSQL";
    // JOB ERRORS
    ErrorCodes["JOB_NOT_FOUND"] = "JOB_NOT_FOUND";
    ErrorCodes["JOB_NOT_FOUND_ON_SCHEDULER"] = "JOB_NOT_FOUND_ON_SCHEDULER";
    // COMMISSION PLAN ERRORS
    ErrorCodes["COMMISSION_PLAN_NOT_FOUND"] = "COMMISSION_PLAN_NOT_FOUND";
    ErrorCodes["COMMISSION_PLAN_INVALID_START_DATE"] = "COMMISSION_PLAN_INVALID_START_DATE";
    ErrorCodes["COMMISSION_PLAN_INVALID_END_DATE"] = "COMMISSION_PLAN_INVALID_END_DATE";
    ErrorCodes["COMMISSION_PLAN_ID_REQUIRED"] = "COMMISSION_PLAN_ID_REQUIRED";
    ErrorCodes["DATASOURCE_DISABLED_INSIDE_PLAN"] = "DATASOURCE_DISABLED_INSIDE_PLAN";
    ErrorCodes["UNKNOWN_TAB_SOURCE_TYPE"] = "UNKNOWN_TAB_SOURCE_TYPE";
    ErrorCodes["COMISSION_PLAN_GROUP_NOT_FOUND"] = "COMISSION_PLAN_GROUP_NOT_FOUND";
    // PAYOUT PERIOD ERRORS
    ErrorCodes["PAYOUT_PERIOD_NOT_FOUND"] = "PAYOUT_PERIOD_NOT_FOUND";
    ErrorCodes["PAYOUT_PERIOD_NOT_VISIBLE"] = "PAYOUT_PERIOD_NOT_VISIBLE";
    ErrorCodes["PAYOUT_PERIOD_REQUIRED"] = "PAYOUT_PERIOD_REQUIRED";
    ErrorCodes["PAYOUT_PERIOD_LOCKED"] = "PAYOUT_PERIOD_LOCKED";
    ErrorCodes["PAYOUT_PERIOD_BY_DATE_NOT_FOUND"] = "PAYOUT_PERIOD_BY_DATE_NOT_FOUND";
    ErrorCodes["PAYOUT_PERIOD_DELETE_LAST"] = "PAYOUT_PERIOD_DELETE_LAST";
    ErrorCodes["PAYOUT_PERIOD_SYNCING"] = "PAYOUT_PERIOD_SYNCING";
    // TAB ERRORS
    ErrorCodes["TAB_NOT_FOUND"] = "TAB_NOT_FOUND";
    ErrorCodes["TAB_WITH_ERRORS"] = "TAB_WITH_ERRORS";
    ErrorCodes["TAB_METADATA_NOT_FOUND"] = "TAB_METADATA_NOT_FOUND";
    ErrorCodes["TAB_SCHEMA_MISSMATCH"] = "TAB_SCHEMA_MISSMATCH";
    ErrorCodes["COLUMN_NOT_FOUND"] = "COLUMN_NOT_FOUND";
    ErrorCodes["COLUMN_NOT_FORMULA"] = "COLUMN_NOT_FORMULA";
    ErrorCodes["COLUMN_TYPE_NOT_ALLOWED"] = "COLUMN_TYPE_NOT_ALLOWED";
    ErrorCodes["TAB_TYPE_NOT_ALLOWED"] = "TAB_TYPE_NOT_ALLOWED";
    ErrorCodes["TAB_FILE_NOT_FOUND"] = "TAB_FILE_NOT_FOUND";
    ErrorCodes["TAB_SOURCE_NOT_ALLOWED_IN_LAYOUT"] = "TAB_SOURCE_NOT_ALLOWED_IN_LAYOUT";
    ErrorCodes["TAB_NON_SOURCE_NOT_ALLOWED_IN_LAYOUT"] = "TAB_NON_SOURCE_NOT_ALLOWED_IN_LAYOUT";
    ErrorCodes["FORBIDDEN_TAB_SCHEMA_CHANGE"] = "FORBIDDEN_TAB_SCHEMA_CHANGE";
    // DATASOURCE ERRORS
    ErrorCodes["DATASOURCE_NOT_FOUND"] = "DATASOURCE_NOT_FOUND";
    ErrorCodes["DATASOURCE_CONFIG_ID_NOT_FOUND"] = "DATASOURCE_CONFIG_ID_NOT_FOUND";
    ErrorCodes["DATASOURCE_ID_REQUIRED"] = "DATASOURCE_ID_REQUIRED";
    ErrorCodes["DUPLICATED_DATASOURCE_CONFIG"] = "DUPLICATED_DATASOURCE_CONFIG";
    ErrorCodes["UNKNOWN_DATASOURCE_TYPE"] = "UNKNOWN_DATASOURCE_TYPE";
    ErrorCodes["UNIQUE_DATASOURCE"] = "UNIQUE_DATASOURCE";
    ErrorCodes["UNEXPECTED_DATASOURCE_CONFIG"] = "UNEXPECTED_DATASOURCE_CONFIG";
    ErrorCodes["DATASOURCE_CONFIG_NOT_FOUND"] = "DATASOURCE_CONFIG_NOT_FOUND";
    ErrorCodes["MISSING_PANEL_ID"] = "MISSING_PANEL_ID";
    ErrorCodes["ONLY_SPREADSHEET_BULK_CREATE_DATASOURCE"] = "ONLY_SPREADSHEET_BULK_CREATE_DATASOURCE";
    // SPREADSHEET ERRORS
    ErrorCodes["GOOGLE_SHEET_NOT_FOUND"] = "GOOGLE_SHEET_NOT_FOUND";
    ErrorCodes["SPREAD_SHEET_NOT_FOUND"] = "SPREAD_SHEET_NOT_FOUND";
    ErrorCodes["WORKSHEET_NOT_FOUND"] = "WORKSHEET_NOT_FOUND";
    // GROUP BY ERRORS
    ErrorCodes["GROUP_BY_INVALID_SOURCE_COLUMN"] = "GROUP_BY_INVALID_SOURCE_COLUMN";
    ErrorCodes["GROUP_BY_INVALID_RESULT_COLUMN"] = "GROUP_BY_INVALID_RESULT_COLUMN";
    ErrorCodes["GROUP_BY_TAB_NOT_FOUND"] = "GROUP_BY_TAB_NOT_FOUND";
    ErrorCodes["GROUP_BY_FILTER_COLUMN_NOT_FOUND"] = "GROUP_BY_FILTER_COLUMN_NOT_FOUND";
    // SUM IF ERRORS
    ErrorCodes["SUM_IF_CYCLIC_DEPENDENCY"] = "SUM_IF_CYCLIC_DEPENDENCY";
    ErrorCodes["SUM_IF_INVALID_SOURCE_COLUMN"] = "SUM_IF_INVALID_SOURCE_COLUMN";
    ErrorCodes["SUM_IF_INVALID_RESULT_COLUMN"] = "SUM_IF_INVALID_RESULT_COLUMN";
    ErrorCodes["SUM_IF_TAB_NOT_FOUND"] = "SUM_IF_TAB_NOT_FOUND";
    ErrorCodes["SUM_IF_FILTER_COLUMN_NOT_FOUND"] = "SUM_IF_FILTER_COLUMN_NOT_FOUND";
    ErrorCodes["SUM_IF_FUNCIONALITY_NOT_IMPLEMENTED"] = "SUM_IF_FUNCIONALITY_NOT_IMPLEMENTED";
    // JOIN ERRORS
    ErrorCodes["JOINED_TAB_NOT_FOUND"] = "JOINED_TAB_NOT_FOUND";
    ErrorCodes["JOINED_COLUMN_NOT_FOUND"] = "JOINED_COLUMN_NOT_FOUND";
    ErrorCodes["JOINED_RESULT_COLUMN_NOT_FOUND"] = "JOINED_RESULT_COLUMN_NOT_FOUND";
    ErrorCodes["MATCH_TAB_NOT_FOUND"] = "MATCH_TAB_NOT_FOUND";
    ErrorCodes["MATCH_COLUMN_NOT_FOUND"] = "MATCH_COLUMN_NOT_FOUND";
    ErrorCodes["MATCH_TAB_NOT_JOINED"] = "MATCH_TAB_NOT_JOINED";
    ErrorCodes["INVALID_MATCH"] = "INVALID_MATCH";
    ErrorCodes["TAB_ALREADY_JOINED"] = "TAB_ALREADY_JOINED";
    ErrorCodes["JOIN_CYCLIC_DEPENDENCY"] = "JOIN_CYCLIC_DEPENDENCY";
    // TASKS ERRORS
    ErrorCodes["INVALID_TASK_METADATA_TYPE"] = "INVALID_TASK_METADATA_TYPE";
    ErrorCodes["TASK_NOT_FOUND"] = "TASK_NOT_FOUND";
    ErrorCodes["JOB_ALREADY_STARTED"] = "JOB_ALREADY_STARTED";
    ErrorCodes["JOB_ALREADY_FINISHED"] = "JOB_ALREADY_FINISHED";
    ErrorCodes["JOB_METADATA_INVALID"] = "JOB_METADATA_INVALID";
    ErrorCodes["JOB_LOCK_NOT_FOUND"] = "JOB_LOCK_NOT_FOUND";
    ErrorCodes["JOB_LOCK_KEY_MISSMATCH"] = "JOB_LOCK_KEY_MISSMATCH";
    ErrorCodes["NOT_ALL_TASKS_FINISHED"] = "NOT_ALL_TASKS_FINISHED";
    ErrorCodes["NOT_ALL_SUBTASKS_FINISHED"] = "NOT_ALL_SUBTASKS_FINISHED";
    ErrorCodes["NEXT_TASKS_ALREADY_STARTED"] = "NEXT_TASKS_ALREADY_STARTED";
    ErrorCodes["TASK_NOT_FINISHED"] = "TASK_NOT_FINISHED";
    ErrorCodes["TASKS_WITHOUT_WAITING_STATUS"] = "TASKS_WITHOUT_WAITING_STATUS";
    ErrorCodes["TASK_ALREADY_FINISHED"] = "TASK_ALREADY_FINISHED";
    ErrorCodes["MIGRATION_CANNOT_BE_CANCELED"] = "MIGRATION_CANNOT_BE_CANCELED";
    ErrorCodes["JOB_LOCK_ALREADY_EXISTS"] = "JOB_LOCK_ALREADY_EXISTS";
    ErrorCodes["CONTROL_LOCK_ALREADY_EXISTS"] = "CONTROL_LOCK_ALREADY_EXISTS";
    ErrorCodes["JOB_ID_NOT_FOUND"] = "JOB_ID_NOT_FOUND";
    ErrorCodes["SUBTASK_ERROR"] = "SUBTASK_ERROR";
    // FORMULA ERRORS
    ErrorCodes["FORMULA_SEMANTIC_ERROR"] = "FORMULA_SEMANTIC_ERROR";
    ErrorCodes["MALFORMED_FORMULA"] = "MALFORMED_FORMULA";
    ErrorCodes["FORMULA_NON_EXISTENT_COLUMN"] = "FORMULA_NON_EXISTENT_COLUMN";
    ErrorCodes["FORMULA_TREE_NODE_TYPE_NOT_ALLOWED"] = "TREE_NODE_TYPE_NOT_ALLOWED";
    ErrorCodes["FORMULA_CYCLIC_DEPENDENCY"] = "FORMULA_CYCLIC_DEPENDENCY";
    // SFTP ERRORS
    ErrorCodes["SFTP_CONNECTION_ERROR"] = "SFTP_CONNECTION_ERROR";
    ErrorCodes["SFTP_LISTING_ERROR"] = "SFTP_LISTING_ERROR";
    ErrorCodes["SFTP_DOWNLOAD_ERROR"] = "SFTP_DOWNLOAD_ERROR";
    ErrorCodes["FAILED_GENERATE_KEY_PAIR"] = "FAILED_GENERATE_KEY_PAIR";
    ErrorCodes["REFERENCED_COLUMN_NOT_FOUND"] = "REFERENCED_COLUMN_NOT_FOUND";
    // S3 ERRORS
    ErrorCodes["S3_CONNECTION_ERROR"] = "S3_CONNECTION_ERROR";
    ErrorCodes["S3_LISTING_ERROR"] = "S3_LISTING_ERROR";
    ErrorCodes["S3_DOWNLOAD_ERROR"] = "S3_DOWNLOAD_ERROR";
    // PROCV ERRORS
    ErrorCodes["BASE_TAB_REQUIRED"] = "BASE_TAB_REQUIRED";
    ErrorCodes["PROCV_BASE_TAB_NOT_FOUND"] = "BASE_TAB_NOT_FOUND";
    ErrorCodes["PROCV_JOINED_TAB_NOT_FOUND"] = "PROCV_JOINED_TAB_NOT_FOUND";
    ErrorCodes["PROCV_RESULT_COLUMN_NOT_FOUND"] = "PROCV_RESULT_COLUMN_NOT_FOUND";
    ErrorCodes["PROCV_JOINED_COLUMN_NOT_FOUND"] = "PROCV_JOINED_COLUMN_NOT_FOUND";
    ErrorCodes["PROCV_FIELD_COLUMN_NOT_FOUND"] = "PROCV_FIELD_COLUMN_NOT_FOUND";
    ErrorCodes["PROCV_MATCH_TAB_NOT_FOUND"] = "PROCV_MATCH_TAB_NOT_FOUND";
    ErrorCodes["PROCV_MATCH_COLUMN_NOT_FOUND"] = "PROCV_MATCH_COLUMN_NOT_FOUND";
    ErrorCodes["PROCV_ORDER_COLUMN_NOT_FOUND"] = "PROCV_ORDER_COLUMN_NOT_FOUND";
    ErrorCodes["PROCV_CYCLIC_DEPENDENCY"] = "PROCV_CYCLIC_DEPENDENCY";
    ErrorCodes["PROCV_FALLBACK_CYCLIC_DEPENDENCY"] = "PROCV_FALLBACK_CYCLIC_DEPENDENCY";
    ErrorCodes["PROCV_CYCLIC_MATCH_DEPENDENCY"] = "PROCV_CYCLIC_MATCH_DEPENDENCY";
    // USER ERRORS
    ErrorCodes["USER_COLUMN_NOT_FOUND"] = "USER_COLUMN_NOT_FOUND";
    ErrorCodes["USER_RESULT_COLUMN_NOT_FOUND"] = "USER_RESULT_COLUMN_NOT_FOUND";
    ErrorCodes["USER_TAB_ALREADY_EXISTS"] = "USER_TAB_ALREADY_EXISTS";
    ErrorCodes["USER_TAB_NOT_FOUND"] = "USER_TAB_NOT_FOUND";
    ErrorCodes["USER_TAB_CYCLIC_DEPENDENCY"] = "USER_TAB_CYCLIC_DEPENDENCY";
    ErrorCodes["USER_TAB_COLUMN_QTD_MISMATCH"] = "USER_TAB_COLUMN_QTD_MISMATCH";
    ErrorCodes["USER_TAB_FILTER_QTD_MISMATCH"] = "USER_TAB_FILTER_QTD_MISMATCH";
    ErrorCodes["USER_CREDITOR_ID_REQUIRED"] = "USER_CREDITOR_ID_REQUIRED";
    // FILTER ERRORS
    ErrorCodes["FILTERED_TAB_NOT_FOUND"] = "FILTERED_TAB_NOT_FOUND";
    ErrorCodes["FILTERED_TAB_COLUMN_NOT_FOUND"] = "FILTERED_TAB_COLUMN_NOT_FOUND";
    ErrorCodes["FILTERED_TAB_FILTER_COLUMN_NOT_FOUND"] = "FILTERED_TAB_FILTER_COLUMN_NOT_FOUND";
    ErrorCodes["FILTERED_TAB_RESULT_COLUMN_NOT_FOUND"] = "FILTERED_TAB_RESULT_COLUMN_NOT_FOUND";
    ErrorCodes["FILTER_EXPRESSION_MUST_BE_BOOLEAN"] = "FILTER_EXPRESSION_MUST_BE_BOOLEAN";
    ErrorCodes["FILTER_COLUMN_NOT_FOUND"] = "FILTER_COLUMN_NOT_FOUND";
    // PLAN VARIABLES ERRORS
    ErrorCodes["PLAN_VARIABLE_NOT_FOUND"] = "PLAN_VARIABLE_NOT_FOUND";
    ErrorCodes["PLAN_NOT_FOUND"] = "PLAN_NOT_FOUND";
    // PULL ERRORS
    ErrorCodes["PULLED_TAB_NOT_FOUND"] = "PULLED_TAB_NOT_FOUND";
    ErrorCodes["PULLED_TAB_COLUMN_NOT_FOUND"] = "PULLED_TAB_COLUMN_NOT_FOUND";
    ErrorCodes["PULLED_TAB_FILTER_COLUMN_NOT_FOUND"] = "PULLED_TAB_FILTER_COLUMN_NOT_FOUND";
    ErrorCodes["PULLED_TAB_RESULT_COLUMN_NOT_FOUND"] = "PULLED_TAB_RESULT_COLUMN_NOT_FOUND";
    // PULL V2 ERRORS
    ErrorCodes["PULL_V2_BLOCKED_IN_FDD"] = "PULL_V2_BLOCKED_IN_FDD";
    ErrorCodes["PULL_V2_UNIFIED_TAB_LIMIT"] = "PULL_V2_UNIFIED_TAB_LIMIT";
    ErrorCodes["PULL_V2_UNIFIED_TAB_NOT_FOUND"] = "PULL_V2_UNIFIED_TAB_NOT_FOUND";
    ErrorCodes["OPERATION_BLOCKED_IN_NON_SOURCES_V2"] = "OPERATION_BLOCKED_IN_NON_SOURCES_V2";
    // UNION ERRORS
    ErrorCodes["UNION_TAB_CYCLIC_DEPENDENCY"] = "UNION_TAB_CYCLIC_DEPENDENCY";
    ErrorCodes["UNION_TAB_NOT_FOUND"] = "UNION_TAB_NOT_FOUND";
    ErrorCodes["UNION_RESULT_COLUMN_NOT_FOUND"] = "UNION_RESULT_COLUMN_NOT_FOUND";
    ErrorCodes["UNION_COLUMN_NOT_FOUND"] = "UNION_COLUMN_NOT_FOUND";
    ErrorCodes["UNION_TAB_COLUMN_QTD_MISMATCH"] = "UNION_TAB_COLUMN_QTD_MISMATCH";
    ErrorCodes["UNION_FILTER_QTD_MISMATCH"] = "UNION_FILTER_QTD_MISMATCH";
    // HISTORICAL ERRORS
    ErrorCodes["HISTORICAL_RESULT_TAB_NOT_FOUND"] = "HISTORICAL_RESULT_TAB_NOT_FOUND";
    ErrorCodes["HISTORICAL_NEW_TABS_CANNOT_SET_MAPPING"] = "HISTORICAL_NEW_TABS_CANNOT_SET_MAPPING";
    ErrorCodes["HISTORICAL_UNIFIED_TAB_NOT_FOUND"] = "HISTORICAL_UNIFIED_TAB_NOT_FOUND";
    ErrorCodes["HISTORICAL_UNIFIED_COLUMN_NOT_FOUND"] = "HISTORICAL_UNIFIED_COLUMN_NOT_FOUND";
    ErrorCodes["HISTORICAL_UNIFIED_FILTER_COL_NOT_FOUND"] = "HISTORICAL_UNIFIED_FILTER_COL_NOT_FOUND";
    ErrorCodes["HISTORICAL_RESULT_COLUMN_NOT_FOUND"] = "HISTORICAL_RESULT_COLUMN_NOT_FOUND";
    ErrorCodes["HISTORICAL_SCHEMA_MAP_COLUMN_NOT_FOUND"] = "HISTORICAL_SCHEMA_MAP_COLUMN_NOT_FOUND";
    ErrorCodes["HISTORICAL_UNIFIED_TAB_GROUPING_NOT_FOUND"] = "HISTORICAL_UNIFIED_TAB_GROUPING_NOT_FOUND";
    ErrorCodes["HISTORICAL_GROUPING_DUPLICATED_TAB_PLAN"] = "HISTORICAL_GROUPING_DUPLICATED_TAB_PLAN";
    ErrorCodes["HISTORICAL_GROUPING_DUPLICATED_PLAN_GROUP"] = "HISTORICAL_GROUPING_DUPLICATED_PLAN_GROUP";
    // UNION V2 ERRORS
    ErrorCodes["UNION_V2_RESULT_TAB_NOT_FOUND"] = "UNION_V2_RESULT_TAB_NOT_FOUND";
    ErrorCodes["UNION_V2_NEW_TABS_CANNOT_SET_MAPPING"] = "UNION_V2_NEW_TABS_CANNOT_SET_MAPPING";
    ErrorCodes["UNION_V2_UNIFIED_TAB_NOT_FOUND"] = "UNION_V2_UNIFIED_TAB_NOT_FOUND";
    ErrorCodes["UNION_V2_UNIFIED_COLUMN_NOT_FOUND"] = "UNION_V2_UNIFIED_COLUMN_NOT_FOUND";
    ErrorCodes["UNION_V2_UNIFIED_GROUPING_COL_NOT_FOUND"] = "UNION_V2_UNIFIED_GROUPING_COL_NOT_FOUND";
    ErrorCodes["UNION_V2_UNIFIED_FILTER_COL_NOT_FOUND"] = "UNION_V2_UNIFIED_FILTER_COL_NOT_FOUND";
    ErrorCodes["UNION_V2_RESULT_COLUMN_NOT_FOUND"] = "UNION_V2_RESULT_COLUMN_NOT_FOUND";
    ErrorCodes["UNION_V2_SCHEMA_MAP_COLUMN_NOT_FOUND"] = "UNION_V2_SCHEMA_MAP_COLUMN_NOT_FOUND";
    ErrorCodes["OPERATION_BLOCKED_IN_SOURCES_V2"] = "OPERATION_BLOCKED_IN_SOURCES_V2";
    // PAYMENT ERRORS
    ErrorCodes["PAYMENT_RESULT_TAB_NOT_FOUND"] = "PAYMENT_RESULT_TAB_NOT_FOUND";
    ErrorCodes["PAYMENT_NEW_TABS_CANNOT_SET_MAPPING"] = "PAYMENT_NEW_TABS_CANNOT_SET_MAPPING";
    ErrorCodes["PAYMENT_UNIFIED_TAB_NOT_FOUND"] = "PAYMENT_UNIFIED_TAB_NOT_FOUND";
    ErrorCodes["PAYMENT_UNIFIED_COLUMN_NOT_FOUND"] = "PAYMENT_UNIFIED_COLUMN_NOT_FOUND";
    ErrorCodes["PAYMENT_LITERAL_VALUE_NOT_ALLOWED"] = "PAYMENT_LITERAL_VALUE_NOT_ALLOWED";
    ErrorCodes["PAYMENT_UNIFIED_FILTER_COL_NOT_FOUND"] = "PAYMENT_UNIFIED_FILTER_COL_NOT_FOUND";
    ErrorCodes["PAYMENT_RESULT_COLUMN_NOT_FOUND"] = "PAYMENT_RESULT_COLUMN_NOT_FOUND";
    ErrorCodes["PAYMENT_SCHEMA_MAP_COLUMN_NOT_FOUND"] = "PAYMENT_SCHEMA_MAP_COLUMN_NOT_FOUND";
    ErrorCodes["PAYMENT_RESULT_COLUMN_CANNOT_CHANGE"] = "PAYMENT_RESULT_COLUMN_CANNOT_CHANGE";
    ErrorCodes["PAYMENT_TAB_ALREADY_EXISTS"] = "PAYMENT_TAB_ALREADY_EXISTS";
    ErrorCodes["PAYMENT_METADATA_COLUMNS_UNMAPPED"] = "PAYMENT_METADATA_COLUMNS_UNMAPPED";
    // WEBHOOK ERRORS
    ErrorCodes["WEBHOOK_NOT_ALLOWED_ON_PLAN"] = "WEBHOOK_NOT_ALLOWED_ON_PLAN";
    ErrorCodes["WEBHOOK_TAB_NOT_FOUND"] = "WEBHOOK_TAB_NOT_FOUND";
    ErrorCodes["WEBHOOK_DATASOURCE_NOT_FOUND"] = "WEBHOOK_DATASOURCE_NOT_FOUND";
    ErrorCodes["WEBHOOK_BASIC_AUTH_IS_REQUIRED"] = "WEBHOOK_BASIC_AUTH_IS_REQUIRED";
    ErrorCodes["WEBHOOK_INVALID_CREDENTIALS"] = "WEBHOOK_INVALID_CREDENTIALS";
    // CRON EXPRESSION ERRORS
    ErrorCodes["MISSING_FIELD_ON_EXPRESSION"] = "MISSING_FIELD_ON_EXPRESSION";
    ErrorCodes["MINUTE_VALUE_NOT_ALLOWED"] = "MINUTE_VALUE_NOT_ALLOWED";
    ErrorCodes["MONTH_VALUE_NOT_ALLOWED"] = "MONTH_VALUE_NOT_ALLOWED";
    ErrorCodes["INVALID_CRON_EXPRESSION"] = "INVALID_CRON_EXPRESSION";
    // SCHEDULE ERRORS
    ErrorCodes["SCHEDULE_JOB_LOCK_ALREADY_EXISTS"] = "SCHEDULE_JOB_LOCK_ALREADY_EXISTS";
    // MANUAL ERRORS
    ErrorCodes["MISSMATCH_COLUMN_QTD"] = "MISSMATCH_COLUMN_QTD";
    ErrorCodes["INVALID_BATCH_SIZE"] = "INVALID_BATCH_SIZE";
    ErrorCodes["MAX_ROW_EXCEDED"] = "MAX_ROW_EXCEDED";
    // DATASET ERRORS
    ErrorCodes["DATASET_NOT_FOUND"] = "DATASET_NOT_FOUND";
    ErrorCodes["BIG_QUERY_FIELD_COLUMN_NOT_FOUND"] = "FIELD_COLUMN_NOT_FOUND";
    ErrorCodes["BIG_QUERY_UPDATED_AT_COLUMN_NOT_FOUND"] = "UPDATED_AT_COLUMN_NOT_FOUND";
    ErrorCodes["BIG_QUERY_INVALID_UPDATED_AT_COLUMN_TYPE"] = "INVALID_UPDATED_AT_COLUMN_TYPE";
    ErrorCodes["BIG_QUERY_CANNOT_UPDATE"] = "BIG_QUERY_CANNOT_UPDATE";
    ErrorCodes["BIG_QUERY_INSIDE_PLAN_REQUIRE_MATCHES"] = "BIG_QUERY_INSIDE_PLAN_REQUIRE_MATCHES";
    ErrorCodes["BIG_QUERY_COLUMNS_LOCKED"] = "BIG_QUERY_COLUMNS_LOCKED";
    ErrorCodes["BIG_QUERY_CYCLIC_DEPENDENCY"] = "BIG_QUERY_CYCLIC_DEPENDENCY";
    // STATEMENT PANEL GENERIC ERRORS
    ErrorCodes["STATEMENT_PANEL_WITH_SAME_NAME_ALREADY_EXISTS"] = "STATEMENT_PANEL_WITH_SAME_NAME_ALREADY_EXISTS";
    ErrorCodes["STATEMENT_PANEL_NOT_FOUND"] = "STATEMENT_PANEL_NOT_FOUND";
    ErrorCodes["STATEMENT_PANEL_ALREADY_CREATED"] = "STATEMENT_PANEL_ALREADY_CREATED";
    ErrorCodes["STATEMENT_PANEL_USER_TAB_ALREADY_EXISTS"] = "STATEMENT_PANEL_USER_TAB_ALREADY_EXISTS";
    ErrorCodes["STATEMENT_PANEL_CANNOT_CHANGE_USER_TAB"] = "STATEMENT_PANEL_CANNOT_CHANGE_USER_TAB";
    ErrorCodes["UNKNOWN_STATEMENT_WIDGET_TYPE"] = "UNKNOWN_STATEMENT_WIDGET_TYPE";
    ErrorCodes["INVALID_WIDGET_CONFIG"] = "INVALID_WIDGET_CONFIG";
    ErrorCodes["WIDGET_MISMATCH_COLUMNS_ID"] = "WIDGET_MISMATCH_COLUMNS_ID";
    ErrorCodes["WIDGET_LAYOUT_INVALID_LENGTH"] = "WIDGET_LAYOUT_INVALID_LENGTH";
    ErrorCodes["WIDGET_NOT_FOUND"] = "WIDGET_NOT_FOUND";
    ErrorCodes["USER_NOT_IN_PERIOD"] = "USER_NOT_IN_PERIOD";
    ErrorCodes["WIDGET_DOWNLOAD_FILE_NOT_FOUND"] = "WIDGET_DOWNLOAD_FILE_NOT_FOUND";
    ErrorCodes["WIDGET_ACTION_FAILED_TO_COMMUNICATE"] = "WIDGET_ACTION_FAILED_TO_COMMUNICATE";
    ErrorCodes["WIDGET_NOT_ON_LAYOUT"] = "WIDGET_NOT_ON_LAYOUT";
    ErrorCodes["WIDGET_INVALID_RLS_CONFIG"] = "WIDGET_INVALID_RLS_CONFIG";
    ErrorCodes["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    // DYNAMIC WIDGET ERRORS
    ErrorCodes["DW_SELECTED_COLUMNS_ID_DUPLICATED"] = "DW_SELECTED_COLUMNS_ID_DUPLICATED";
    ErrorCodes["DW_GROUP_BY_SELECTED_COLUMN_NOT_FOUND"] = "DW_GROUP_BY_SELECTED_COLUMN_NOT_FOUND";
    ErrorCodes["DW_GROUP_BY_SUMMARIZED_COLUMN_NOT_FOUND"] = "DW_GROUP_BY_SUMMARIZED_COLUMN_NOT_FOUND";
    ErrorCodes["DW_DUPLICATED_SUMMARIZED_COLUMN"] = "DW_DUPLICATED_SUMMARIZED_COLUMN";
    ErrorCodes["DW_DUPLICATED_GROUP_BY_COLUMN"] = "DW_DUPLICATED_GROUP_BY_COLUMN";
    ErrorCodes["DW_CANT_SUMMARIZE_GROUPED_COLUMN"] = "DW_CANT_SUMMARIZE_GROUPED_COLUMN";
    // PAYROLL ERRORS
    ErrorCodes["PAYROLL_DATA_NOT_FOUND"] = "PAYROLL_DATA_NOT_FOUND";
    ErrorCodes["SOME_PLAN_IS_SYNCING"] = "SOME_PLAN_IS_SYNCING";
    // MIGRATION ERRORS
    ErrorCodes["MIGRATION_NOT_ALLOWED"] = "MIGRATION_NOT_ALLOWED";
    ErrorCodes["ALLOWED_ONLY_CALC_ON_BQ"] = "ALLOWED_ONLY_CALC_ON_BQ";
    // DOCUMENT SIGNER ERRORS
    ErrorCodes["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    ErrorCodes["PACKET_NOT_FOUND"] = "PACKET_NOT_FOUND";
    ErrorCodes["DOCUMENT_NOT_PENDING_PREPARE_DATA"] = "DOCUMENT_NOT_PENDING_PREPARE_DATA";
    ErrorCodes["PACKET_NOT_PENDING"] = "PACKET_NOT_PENDING";
    ErrorCodes["SIGNER_NOT_FOUND"] = "SIGNER_NOT_FOUND";
    // INQUIRY ERRORS
    ErrorCodes["INQUIRY_CREATION_OVERDUE"] = "INQUIRY_CREATION_OVERDUE";
})(ErrorCodes = exports.ErrorCodes || (exports.ErrorCodes = {}));
const statementErrors = {
    [ErrorCodes.USER_NOT_IN_PERIOD]: {
        status: 400,
        description: 'Usuário não está presente no período',
        data: ['user_id', 'period_id'],
    },
    [ErrorCodes.USER_NOT_FOUND]: {
        status: 404,
        description: 'Usuário não encontrado',
        data: ['creditor_id'],
    },
    [ErrorCodes.STATEMENT_PANEL_NOT_FOUND]: {
        status: 400,
        description: 'Painel de extrato não encontrado',
        data: ['name'],
    },
    [ErrorCodes.STATEMENT_PANEL_WITH_SAME_NAME_ALREADY_EXISTS]: {
        status: 400,
        description: 'Extrato com o mesmo nome já existe',
        data: ['statement_id', 'plan_id'],
    },
    [ErrorCodes.UNKNOWN_STATEMENT_WIDGET_TYPE]: {
        status: 400,
        description: 'Tipo de widget inválido',
        data: ['widget_type', 'statement_id'],
    },
    [ErrorCodes.WIDGET_MISMATCH_COLUMNS_ID]: {
        status: 400,
        description: 'Configuração de widget inválida',
        data: ['widget'],
    },
    [ErrorCodes.WIDGET_NOT_FOUND]: {
        status: 404,
        description: 'Widget não encontrado',
        data: ['widget_id', 'statement_panel_id'],
    },
    [ErrorCodes.INVALID_WIDGET_CONFIG]: {
        status: 400,
        description: 'Configuração de widget inválida',
        data: ['statement_panel_id', 'config'],
    },
    [ErrorCodes.STATEMENT_PANEL_ALREADY_CREATED]: {
        status: 400,
        description: 'Painel de extrato já criado para este plano de comissão',
        data: ['comission_plan_id'],
    },
    [ErrorCodes.WIDGET_DOWNLOAD_FILE_NOT_FOUND]: {
        status: 404,
        description: 'Arquivo de download do widget não encontrado',
        data: ['fileId', 'statement_panel_id'],
    },
    [ErrorCodes.WIDGET_ACTION_FAILED_TO_COMMUNICATE]: {
        status: 502,
        description: 'Ação do widget falhou ao comunicar',
        data: ['statement_panel_id', 'url', 'message'],
    },
    [ErrorCodes.STATEMENT_PANEL_USER_TAB_ALREADY_EXISTS]: {
        status: 400,
        description: 'A aba do usuário já existe',
        data: ['statement_panel_id'],
    },
    [ErrorCodes.STATEMENT_PANEL_CANNOT_CHANGE_USER_TAB]: {
        status: 400,
        description: 'Não é possível alterar a aba do usuário',
        data: ['statement_panel_id'],
    },
    [ErrorCodes.WIDGET_LAYOUT_INVALID_LENGTH]: {
        status: 400,
        description: 'Tamanho do layout e dos widgets invalido',
        data: [],
    },
    [ErrorCodes.WIDGET_NOT_ON_LAYOUT]: {
        status: 400,
        description: 'Widget não está no layout',
        data: ['statement_panel_id', 'widget'],
    },
    [ErrorCodes.WIDGET_INVALID_RLS_CONFIG]: {
        status: 400,
        description: 'Coluna de usuário deve ser selecionada quando a segurança a nível de usuário estiver habilitado',
        data: [],
    },
};
const dynamicTableErrors = {
    [ErrorCodes.DW_SELECTED_COLUMNS_ID_DUPLICATED]: {
        status: 400,
        description: 'Colunas selecionadas duplicadas',
        data: ['selected_column_id'],
    },
    [ErrorCodes.DW_GROUP_BY_SELECTED_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna selecionada para agrupar não encontrada',
        data: ['selected_column_id'],
    },
    [ErrorCodes.DW_GROUP_BY_SUMMARIZED_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna selecionada para sumarizar não encontrada',
        data: ['selected_column_id'],
    },
    [ErrorCodes.DW_DUPLICATED_SUMMARIZED_COLUMN]: {
        status: 400,
        description: 'Coluna sumarizada duplicada para este agrupamento',
        data: ['summarize_column_id', 'grouping_column_id'],
    },
    [ErrorCodes.DW_DUPLICATED_GROUP_BY_COLUMN]: {
        status: 400,
        description: 'Coluna agrupada duplicada',
        data: ['selected_column_id'],
    },
    [ErrorCodes.DW_CANT_SUMMARIZE_GROUPED_COLUMN]: {
        status: 400,
        description: 'Não é possível sumarizar uma coluna usada em um agrupamento',
        data: ['summarize_column_id', 'grouping_column_id'],
    },
};
const unionErrors = {
    [ErrorCodes.UNION_TAB_CYCLIC_DEPENDENCY]: {
        status: 400,
        description: 'A configuração de união tab_id não pode ser igual à tab_id do datasource',
        data: ['tab_id', 'datasource_id'],
    },
    [ErrorCodes.UNION_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Tab de união não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.UNION_RESULT_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de resultado de união não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.UNION_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de origem de união não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.UNION_TAB_COLUMN_QTD_MISMATCH]: {
        status: 400,
        description: 'Quantidade de colunas da tab de união não coincide',
        data: ['tab_id'],
    },
    [ErrorCodes.UNION_FILTER_QTD_MISMATCH]: {
        status: 400,
        description: 'Quantidade de filtros de união não coincide',
        data: ['tab_id'],
    },
};
const unionV2Errors = {
    [ErrorCodes.UNION_V2_RESULT_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba de resultado da união não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.UNION_V2_UNIFIED_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba unificada não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.UNION_V2_NEW_TABS_CANNOT_SET_MAPPING]: {
        status: 400,
        description: 'Novas abas não podem definir mapeamento',
        data: [],
    },
    [ErrorCodes.UNION_V2_UNIFIED_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna unificada não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.UNION_V2_UNIFIED_GROUPING_COL_NOT_FOUND]: {
        status: 400,
        description: 'Coluna unificada não encontrada na agrupação',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.UNION_V2_UNIFIED_FILTER_COL_NOT_FOUND]: {
        status: 400,
        description: 'Coluna unificada não encontrada no filtro',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.UNION_V2_RESULT_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de resultado da união não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.UNION_V2_SCHEMA_MAP_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de mapeamento de esquema de união não encontrada',
        data: ['column_id'],
    },
    [ErrorCodes.OPERATION_BLOCKED_IN_SOURCES_V2]: {
        status: 400,
        description: 'Operação não permitida para fontes v2',
        data: ['datasource_id'],
    },
};
const historicalErrors = {
    [ErrorCodes.HISTORICAL_RESULT_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba de resultado da união não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.HISTORICAL_UNIFIED_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba unificada não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.HISTORICAL_NEW_TABS_CANNOT_SET_MAPPING]: {
        status: 400,
        description: 'Novas abas não podem definir mapeamento',
        data: [],
    },
    [ErrorCodes.HISTORICAL_UNIFIED_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna unificada não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.HISTORICAL_UNIFIED_FILTER_COL_NOT_FOUND]: {
        status: 400,
        description: 'Coluna unificada não encontrada no filtro',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.HISTORICAL_RESULT_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de resultado da união não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.HISTORICAL_SCHEMA_MAP_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de mapeamento de esquema de união não encontrada',
        data: ['column_id'],
    },
    [ErrorCodes.HISTORICAL_UNIFIED_TAB_GROUPING_NOT_FOUND]: {
        status: 400,
        description: 'Configuração de agrupamento não encontrada.',
        data: ['tab_grouping_key'],
    },
    [ErrorCodes.HISTORICAL_GROUPING_DUPLICATED_TAB_PLAN]: {
        status: 400,
        description: 'A configuração de agrupamento permite apenas uma tab por plano.',
        data: ['tab_grouping_key'],
    },
    [ErrorCodes.HISTORICAL_GROUPING_DUPLICATED_PLAN_GROUP]: {
        status: 400,
        description: 'A configuração de agrupamento precisa ser do mesmo Grupo de Plano.',
        data: ['tab_grouping_key'],
    },
    [ErrorCodes.OPERATION_BLOCKED_IN_SOURCES_V2]: {
        status: 400,
        description: 'Operação não permitida para fontes v2',
        data: ['datasource_id'],
    },
};
const paymentErrors = {
    [ErrorCodes.PAYMENT_RESULT_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba de resultado do pagamento não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.PAYMENT_UNIFIED_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba unificada não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.PAYMENT_NEW_TABS_CANNOT_SET_MAPPING]: {
        status: 400,
        description: 'Novas abas não podem definir mapeamento',
        data: [],
    },
    [ErrorCodes.PAYMENT_UNIFIED_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna unificada não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.PAYMENT_UNIFIED_FILTER_COL_NOT_FOUND]: {
        status: 400,
        description: 'Coluna unificada não encontrada no filtro',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.PAYMENT_RESULT_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de resultado do pagamento não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.PAYMENT_SCHEMA_MAP_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de mapeamento de esquema do pagamento não encontrada',
        data: ['column_id'],
    },
    [ErrorCodes.PAYMENT_RESULT_COLUMN_CANNOT_CHANGE]: {
        status: 400,
        description: 'Coluna de resultado do pagamento no mapeamento do esquema da aba não pode ser alterada',
        data: ['column_id'],
    },
    [ErrorCodes.PAYMENT_LITERAL_VALUE_NOT_ALLOWED]: {
        status: 400,
        description: 'Valor literal não permitido para a coluna recebida',
        data: ['tab_id', 'column_name'],
    },
    [ErrorCodes.PAYMENT_TAB_ALREADY_EXISTS]: {
        status: 400,
        description: 'A aba de pagamento já existe',
        data: ['tab_id', 'plan_id'],
    },
    [ErrorCodes.PAYMENT_METADATA_COLUMNS_UNMAPPED]: {
        status: 400,
        description: 'Pelo menos uma coluna de metadados deve ser mapeada',
        data: ['config'],
    },
};
const genericErrors = {
    [ErrorCodes.TAB_LOCKED]: {
        status: 400,
        description: 'A aba está bloqueada por um período de pagamento',
        data: ['tab_id', 'plan_id'],
    },
    [ErrorCodes.INTERNAL_ERROR]: {
        status: 500,
        description: 'Erro interno',
        data: [],
    },
    [ErrorCodes.GOOGLE_PUBSUB_SEND_MESSAGE_ERROR]: {
        status: 500,
        description: 'Erro ao enviar mensagem para o Pub/Sub',
        data: ['message', 'error', 'topic'],
    },
    [ErrorCodes.GOOGLE_SECRET_MANAGER_ACCESS_SECRET_ERROR]: {
        status: 500,
        description: 'Erro ao acessar segredo no Secret Manager',
        data: ['secretName', 'error'],
    },
    [ErrorCodes.GOOGLE_SECRET_MANAGER_SET_SECRET_ERROR]: {
        status: 500,
        description: 'Erro ao definir segredo no Secret Manager',
        data: ['secretName', 'error'],
    },
    [ErrorCodes.GOOGLE_SECRET_MANAGER_DELETE_SECRET_ERROR]: {
        status: 500,
        description: 'Erro ao excluir segredo no Secret Manager',
        data: ['secretName', 'error'],
    },
    [ErrorCodes.GRAPH_CYCLE_FOUND]: {
        status: 400,
        description: 'Ciclo de dependência detectado',
        data: ['sourceNodeKey', 'targetNodeKey'],
    },
    [ErrorCodes.INVALID_COLUMN_TO_DELETE]: {
        status: 400,
        description: 'A coluna a ser excluída deve ser do tipo de nó FORMULA',
        data: ['columnId', 'columnNodeType'],
    },
    [ErrorCodes.REFERENCED_NODE_WITH_ERROR]: {
        status: 400,
        description: 'Nó referenciado com erro',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.INVALID_RESULT_COLUMN_ID]: {
        status: 400,
        description: 'O ID da coluna de resultado é inválido',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.INVALID_ROUNDING_OPTS_FOR_COLUMN]: {
        status: 400,
        description: 'As opções de arredondamento não são válidas para abas de origem',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.DOWNLOAD_FILE_NOT_FOUND]: {
        status: 400,
        description: 'Arquivo para download não encontrado',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.NODE_NOT_FOUND]: {
        status: 500,
        description: 'Não foi possível criar uma aresta porque um nó não foi encontrado',
        data: ['missing_node_key', 'source', 'target'],
    },
    [ErrorCodes.DUPLICATED_SOURCE_COLUMN]: {
        status: 400,
        description: 'Colunas de origem estão duplicadas',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.INVALID_INPUT]: {
        status: 400,
        description: 'Erro de validação',
        data: ['errors'],
    },
    [ErrorCodes.NODE_TYPE_NOT_ALLOWED]: {
        status: 400,
        description: 'Tipo de nó não permitido',
        data: ['errors'],
    },
    [ErrorCodes.DISABLED_FOR_TABSOURCE_TYPE_MYSQL]: {
        status: 400,
        description: 'Funcionalidade desativada para fonte de dados/ou plano no MySQL',
        data: ['tab_id', 'datasource_id'],
    },
    [ErrorCodes.FORBIDDEN_TAB_SCHEMA_CHANGE]: {
        status: 400,
        description: 'Alteração das colunas não permitida',
        data: [],
    },
};
const payoutPlanErrors = {
    [ErrorCodes.PAYOUT_PERIOD_NOT_FOUND]: {
        status: 404,
        description: 'Período de pagamento não encontrado',
        data: ['office_id', 'commission_plan_id', 'payout_period_id'],
    },
    [ErrorCodes.PAYOUT_PERIOD_BY_DATE_NOT_FOUND]: {
        status: 404,
        description: 'Período de pagamento não encontrado',
        data: ['office_id', 'commission_plan_id', 'start_date'],
    },
    [ErrorCodes.PAYOUT_PERIOD_NOT_VISIBLE]: {
        status: 403,
        description: 'Período de pagamento não está visível',
        data: ['office_id', 'commission_plan_id', 'payout_period_id'],
    },
    [ErrorCodes.PAYOUT_PERIOD_REQUIRED]: {
        status: 400,
        description: 'O ID do período de pagamento é obrigatório',
        data: ['office_id', 'commission_plan_id'],
    },
    [ErrorCodes.PAYOUT_PERIOD_LOCKED]: {
        status: 400,
        description: 'O período de pagamento está bloqueado',
        data: ['office_id', 'commission_plan_id'],
    },
    [ErrorCodes.PAYOUT_PERIOD_DELETE_LAST]: {
        status: 400,
        description: 'Não é possível remover o único período de pagamento de um plano',
        data: ['office_id', 'commission_plan_id', 'payout_period_id'],
    },
    [ErrorCodes.PAYOUT_PERIOD_SYNCING]: {
        status: 400,
        description: 'A ação não pode ser feita pois o período está sincronizando',
        data: ['office_id', 'commission_plan_id', 'payout_period_id'],
    },
};
const commissionPlanErrors = {
    [ErrorCodes.UNKNOWN_TAB_SOURCE_TYPE]: {
        status: 400,
        description: 'Tipo de fonte da aba desconhecido',
        data: ['type'],
    },
    [ErrorCodes.COMMISSION_PLAN_NOT_FOUND]: {
        status: 404,
        description: 'Plano de comissão não encontrado',
        data: ['office_id', 'commission_plan_id'],
    },
    [ErrorCodes.DATASOURCE_DISABLED_INSIDE_PLAN]: {
        status: 400,
        description: 'Fonte de dados está desativada dentro do plano',
        data: ['office_id', 'datasource_type'],
    },
    [ErrorCodes.COMMISSION_PLAN_INVALID_START_DATE]: {
        status: 400,
        description: 'Data de início é inválida',
        data: ['office_id'],
    },
    [ErrorCodes.COMMISSION_PLAN_INVALID_END_DATE]: {
        status: 400,
        description: 'Data de término é inválida',
        data: ['office_id'],
    },
    [ErrorCodes.COMMISSION_PLAN_ID_REQUIRED]: {
        status: 400,
        description: 'O ID do plano de comissão é obrigatório',
        data: ['office_id', 'config'],
    },
    [ErrorCodes.COMISSION_PLAN_GROUP_NOT_FOUND]: {
        status: 400,
        description: 'Grupo de plano não encontrado',
        data: ['group_id'],
    },
};
const tabErrors = {
    [ErrorCodes.TAB_METADATA_NOT_FOUND]: {
        status: 404,
        description: 'Metadados da aba não encontrados para o office_id solicitado',
        data: ['office_id'],
    },
    [ErrorCodes.TAB_TYPE_NOT_ALLOWED]: {
        status: 400,
        description: 'Operação não permitida para este tipo de aba',
        data: ['type', 'tab_id'],
    },
    [ErrorCodes.TAB_NOT_FOUND]: {
        status: 404,
        description: 'Aba não encontrada',
        data: ['office_id', 'tab_id'],
    },
    [ErrorCodes.TAB_WITH_ERRORS]: {
        status: 400,
        description: 'A aba contém erros. Verifique e corrija os problemas para continuar.',
        data: ['office_id', 'tab_id'],
    },
    [ErrorCodes.TAB_SCHEMA_MISSMATCH]: {
        status: 400,
        description: 'Esquemas de aba e fonte de dados não coincidem',
        data: ['tabSchema', 'datasourceSchema'],
    },
    [ErrorCodes.COLUMN_NOT_FOUND]: {
        status: 404,
        description: 'Coluna não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.COLUMN_NOT_FORMULA]: {
        status: 400,
        description: 'Fórmulas não permitidas neste tipo de coluna',
        data: ['tab_id', 'column_id', 'column_type'],
    },
    [ErrorCodes.COLUMN_TYPE_NOT_ALLOWED]: {
        status: 400,
        description: 'Operação não permitida para este tipo de coluna',
        data: ['tab_id', 'column_id', 'column_type'],
    },
    [ErrorCodes.TAB_FILE_NOT_FOUND]: {
        status: 404,
        description: 'Arquivo não encontrado.',
        data: ['fileId', 'fileName', 'tabId', 'payoutPeriodId', 'tabVersionToSearch'],
    },
    [ErrorCodes.TAB_SOURCE_NOT_ALLOWED_IN_LAYOUT]: {
        status: 400,
        description: 'Fonte de aba não permitida no layout.',
        data: ['office_id', 'tab_id'],
    },
    [ErrorCodes.TAB_NON_SOURCE_NOT_ALLOWED_IN_LAYOUT]: {
        status: 400,
        description: 'Aba não de fonte não permitida nos layouts de fontes.',
        data: ['office_id', 'tab_id'],
    },
};
const datasourceErrors = {
    [ErrorCodes.ONLY_SPREADSHEET_BULK_CREATE_DATASOURCE]: {
        status: 500,
        description: 'Criação em massa de datasources permitida apenas para datasources do tipo planilha',
        data: ['type'],
    },
    [ErrorCodes.UNKNOWN_DATASOURCE_TYPE]: {
        status: 500,
        description: 'Tipo de fonte de dados desconhecido detectado',
        data: ['config'],
    },
    [ErrorCodes.UNIQUE_DATASOURCE]: {
        status: 400,
        description: 'A aba deve ter apenas uma fonte de dados',
        data: ['tab_id', 'type'],
    },
    [ErrorCodes.UNEXPECTED_DATASOURCE_CONFIG]: {
        status: 400,
        description: 'Fonte de dados inesperada recebida',
        data: ['config', 'type'],
    },
    [ErrorCodes.DATASOURCE_CONFIG_NOT_FOUND]: {
        status: 400,
        description: 'Configuração da fonte de dados não encontrada',
        data: ['config', 'type'],
    },
    [ErrorCodes.DATASOURCE_ID_REQUIRED]: {
        status: 400,
        description: 'O ID da fonte de dados é obrigatório',
        data: [],
    },
    [ErrorCodes.DUPLICATED_DATASOURCE_CONFIG]: {
        status: 400,
        description: 'Configuração de fonte de dados duplicada',
        data: ['existentConfig', 'config'],
    },
    [ErrorCodes.DATASOURCE_NOT_FOUND]: {
        status: 404,
        description: 'Fonte de dados não encontrada',
        data: ['tab_id', 'datasource_id'],
    },
    [ErrorCodes.MISSING_PANEL_ID]: {
        status: 400,
        description: 'ID do painel ausente durante a criação de fonte de dados do usuário',
        data: ['datasource_id'],
    },
    [ErrorCodes.DATASOURCE_CONFIG_ID_NOT_FOUND]: {
        status: 404,
        description: 'Id de configuração de datasource não encontrada',
        data: ['tab_id', 'datasource_id'],
    },
};
const spreadsheetErrors = {
    [ErrorCodes.GOOGLE_SHEET_NOT_FOUND]: {
        status: 404,
        description: 'Planilha do Google não encontrada',
        data: ['id'],
    },
    [ErrorCodes.SPREAD_SHEET_NOT_FOUND]: {
        status: 404,
        description: 'Planilha não encontrada',
        data: ['id'],
    },
    [ErrorCodes.WORKSHEET_NOT_FOUND]: {
        status: 404,
        description: 'Planilha não encontrada',
        data: ['worksheetName'],
    },
};
const sumIfErrors = {
    [ErrorCodes.SUM_IF_CYCLIC_DEPENDENCY]: {
        status: 400,
        description: 'A coluna de origem do sumif não pode ser uma coluna de resultado do sumif da mesma configuração',
        data: ['column_id', 'datasource_id', 'tab_id'],
    },
    [ErrorCodes.SUM_IF_INVALID_RESULT_COLUMN]: {
        status: 400,
        description: 'Coluna de resultado do sumif não encontrada',
        data: ['column_id'],
    },
    [ErrorCodes.SUM_IF_INVALID_SOURCE_COLUMN]: {
        status: 400,
        description: 'Coluna de origem do sumif não encontrada',
        data: ['source_column_id'],
    },
    [ErrorCodes.SUM_IF_FILTER_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de filtro do sumif não encontrada',
        data: ['source_column_id'],
    },
    [ErrorCodes.SUM_IF_TAB_NOT_FOUND]: {
        status: 404,
        description: 'Aba de origem do sumif não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.SUM_IF_FUNCIONALITY_NOT_IMPLEMENTED]: {
        status: 404,
        description: 'O sumif não suporta puxar de outra aba',
        data: ['tab_id', 'source_tab_id'],
    },
};
const groupByErrors = {
    [ErrorCodes.GROUP_BY_INVALID_RESULT_COLUMN]: {
        status: 400,
        description: 'Coluna de resultado do agrupamento não encontrada',
        data: ['column_id'],
    },
    [ErrorCodes.GROUP_BY_INVALID_SOURCE_COLUMN]: {
        status: 400,
        description: 'Coluna de origem do agrupamento não encontrada',
        data: ['source_column_id'],
    },
    [ErrorCodes.GROUP_BY_FILTER_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de filtro do agrupamento não encontrada',
        data: ['source_column_id'],
    },
    [ErrorCodes.GROUP_BY_TAB_NOT_FOUND]: {
        status: 404,
        description: 'Aba de origem do agrupamento não encontrada',
        data: ['tab_id'],
    },
};
const joinErrors = {
    [ErrorCodes.JOINED_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba unida não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.JOINED_RESULT_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de resultado da união não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.JOINED_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna unida não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.MATCH_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de correspondência não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.MATCH_TAB_NOT_JOINED]: {
        status: 400,
        description: 'As abas de correspondência devem ser unidas (ou ser base) antes de serem usadas em correspondências',
        data: ['match_index', 'join_index', 'match_tab_id'],
    },
    [ErrorCodes.MATCH_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba correspondente não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.INVALID_MATCH]: {
        status: 400,
        description: 'Match inválido',
        data: ['match'],
    },
    [ErrorCodes.TAB_ALREADY_JOINED]: {
        status: 400,
        description: 'A aba unida já foi unida em uma junção anterior ou como aba base',
        data: ['tab_id', 'config'],
    },
    [ErrorCodes.JOIN_CYCLIC_DEPENDENCY]: {
        status: 400,
        description: 'A aba de junção não pode ser uma aba de junção da mesma configuração',
        data: ['datasource_id', 'tab_id'],
    },
};
const taskErrors = {
    [ErrorCodes.INVALID_TASK_METADATA_TYPE]: {
        status: 500,
        description: 'Metadados da tarefa têm tipo inválido',
        data: ['task_id', 'expected_type'],
    },
    [ErrorCodes.CONTROL_LOCK_ALREADY_EXISTS]: {
        status: 202,
        description: 'Outro processo já criou esse bloqueio',
        data: ['job_id'],
    },
    [ErrorCodes.TASK_NOT_FOUND]: {
        status: 202,
        description: 'O task_id recebido não foi encontrado. ignorando mensagem',
        data: ['task_id'],
    },
    [ErrorCodes.JOB_LOCK_NOT_FOUND]: {
        status: 202,
        description: 'Bloqueio de trabalho não encontrado. ignorando mensagem',
        data: ['office_id', 'plan_id'],
    },
    [ErrorCodes.JOB_ALREADY_STARTED]: {
        status: 202,
        description: 'Trabalho já iniciado. ignorando mensagem',
        data: ['job_id'],
    },
    [ErrorCodes.JOB_METADATA_INVALID]: {
        status: 202,
        description: 'Metadados do trabalho são inválidos',
        data: ['job_id'],
    },
    [ErrorCodes.JOB_ALREADY_FINISHED]: {
        status: 202,
        description: 'Trabalho já concluído. ignorando mensagem',
        data: ['job_id'],
    },
    [ErrorCodes.JOB_LOCK_KEY_MISSMATCH]: {
        status: 202,
        description: 'Bloqueio de trabalho encontrado, mas o job_id não coincidiu. ignorando mensagem',
        data: ['job_id'],
    },
    [ErrorCodes.NOT_ALL_TASKS_FINISHED]: {
        status: 202,
        description: 'Nem todas as próximas tarefas foram concluídas. ignorando mensagem',
        data: ['job_id'],
    },
    [ErrorCodes.TASK_ALREADY_FINISHED]: {
        status: 202,
        description: 'Tarefa já concluída. ignorando mensagem',
        data: ['task_id'],
    },
    [ErrorCodes.NOT_ALL_SUBTASKS_FINISHED]: {
        status: 202,
        description: 'Nem todas as próximas subtarefas foram concluídas. ignorando mensagem',
        data: ['job_id'],
    },
    [ErrorCodes.NEXT_TASKS_ALREADY_STARTED]: {
        status: 202,
        description: 'Os estados das próximas tarefas não são esperando. ignorando mensagem',
        data: ['job_id'],
    },
    [ErrorCodes.TASK_NOT_FINISHED]: {
        status: 202,
        description: 'O status da tarefa não está concluído. ignorando mensagem',
        data: ['task_id'],
    },
    [ErrorCodes.TASKS_WITHOUT_WAITING_STATUS]: {
        status: 400,
        description: 'As tarefas não têm tarefa de espera',
        data: [],
    },
    [ErrorCodes.JOB_LOCK_ALREADY_EXISTS]: {
        status: 423,
        description: 'Já há um trabalho em andamento',
        data: ['office_id', 'plan_id'],
    },
    [ErrorCodes.JOB_ID_NOT_FOUND]: {
        status: 404,
        description: 'ID do trabalho não encontrado',
        data: ['jobLock', 'office_id', 'commission_plan_id', 'payout_period_id'],
    },
    [ErrorCodes.MIGRATION_CANNOT_BE_CANCELED]: {
        status: 400,
        description: 'A migração não pode ser cancelada',
        data: ['office_id', 'plan_id', 'period_id'],
    },
    [ErrorCodes.SUBTASK_ERROR]: {
        status: 400,
        description: 'Falha ao processar subtask',
        data: ['office_id', 'job_id', 'task_id', 'subtask_id'],
    },
};
const formulaErrors = {
    [ErrorCodes.FORMULA_SEMANTIC_ERROR]: {
        status: 400,
        description: 'A fórmula possui um erro semântico',
        data: ['token', 'semantic_error_code', 'semantic_error_message'],
    },
    [ErrorCodes.FORMULA_CYCLIC_DEPENDENCY]: {
        status: 400,
        description: 'A coluna de origem da fórmula não pode ser uma coluna de resultado da mesma configuração',
        data: ['tab_id', 'datasource_id'],
    },
    [ErrorCodes.MALFORMED_FORMULA]: {
        status: 400,
        description: 'A fórmula possui um erro',
        data: ['error_type', 'message', 'from', 'to', 'severity'],
    },
    [ErrorCodes.REFERENCED_COLUMN_NOT_FOUND]: {
        status: 404,
        description: 'Coluna referenciada não encontrada',
        data: ['column_id', 'tab_id'],
    },
    [ErrorCodes.FORMULA_NON_EXISTENT_COLUMN]: {
        status: 500,
        description: 'Tentando alterar uma coluna inexistente no grafo',
        data: ['columnNodeKey'],
    },
    [ErrorCodes.FORMULA_TREE_NODE_TYPE_NOT_ALLOWED]: {
        status: 400,
        description: 'Tipo de nó de árvore não permitido',
        data: ['tab_id'],
    },
};
const procvErrors = {
    [ErrorCodes.BASE_TAB_REQUIRED]: {
        status: 400,
        description: 'É necessário ter uma aba base para criar um procv',
        data: [],
    },
    [ErrorCodes.PROCV_BASE_TAB_NOT_FOUND]: {
        status: 404,
        description: 'Aba base não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.PROCV_JOINED_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba unida procv não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.PROCV_MATCH_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba correspondente procv não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.PROCV_MATCH_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna correspondente procv não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.PROCV_JOINED_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna unida procv não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.PROCV_FIELD_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de campo procv não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.PROCV_RESULT_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de resultado procv não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.PROCV_ORDER_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de ordem procv não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.PROCV_CYCLIC_DEPENDENCY]: {
        status: 400,
        description: 'A coluna de origem procv não pode ser uma coluna de resultado procv da mesma configuração',
        data: ['column_id', 'datasource_id', 'tab_id'],
    },
    [ErrorCodes.PROCV_FALLBACK_CYCLIC_DEPENDENCY]: {
        status: 400,
        description: 'A fórmula de fallback não pode usar uma coluna de resultado do procv da mesma configuração',
        data: ['column_id', 'datasource_id', 'tab_id'],
    },
    [ErrorCodes.PROCV_CYCLIC_MATCH_DEPENDENCY]: {
        status: 400,
        description: 'A coluna de correspondência procv não pode ser uma coluna de resultado procv da mesma configuração',
        data: ['column_id', 'datasource_id', 'tab_id'],
    },
};
const sftpErrors = {
    [ErrorCodes.SFTP_CONNECTION_ERROR]: {
        status: 400,
        description: 'Houve um erro com a conexão',
        data: [],
    },
    [ErrorCodes.SFTP_LISTING_ERROR]: {
        status: 400,
        description: 'Houve um erro durante a listagem',
        data: [],
    },
    [ErrorCodes.SFTP_DOWNLOAD_ERROR]: {
        status: 400,
        description: 'Houve um erro durante o download',
        data: [],
    },
    [ErrorCodes.FAILED_GENERATE_KEY_PAIR]: {
        status: 400,
        description: 'Houve um erro ao gerar o par de chaves',
        data: [],
    },
};
const s3Errors = {
    [ErrorCodes.S3_CONNECTION_ERROR]: {
        status: 400,
        description: 'Houve um erro com a conexão',
        data: [],
    },
    [ErrorCodes.S3_DOWNLOAD_ERROR]: {
        status: 400,
        description: 'Houve um erro durante o download',
        data: [],
    },
    [ErrorCodes.S3_LISTING_ERROR]: {
        status: 400,
        description: 'Houve um erro durante a listagem',
        data: [],
    },
};
const filterErrors = {
    [ErrorCodes.FILTERED_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba filtrada não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.FILTERED_TAB_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna filtrada da aba filtrada não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.FILTERED_TAB_FILTER_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de filtro da aba filtrada não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.FILTERED_TAB_RESULT_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de resultado não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.FILTER_EXPRESSION_MUST_BE_BOOLEAN]: {
        status: 400,
        description: 'A expressão de filtro deve ser booleana',
        data: ['expression'],
    },
    [ErrorCodes.FILTER_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de filtro não encontrada',
        data: [],
    },
};
const userErrors = {
    [ErrorCodes.USER_TAB_COLUMN_QTD_MISMATCH]: {
        status: 400,
        description: 'O id da aba de configuração do usuário não pode ser o mesmo que o id da aba de origem de dados',
        data: ['tab_id', 'datasource_id'],
    },
    [ErrorCodes.USER_TAB_FILTER_QTD_MISMATCH]: {
        status: 400,
        description: 'A quantidade de filtros não pode ser diferente da quantidade de abas unidas',
        data: [],
    },
    [ErrorCodes.USER_TAB_CYCLIC_DEPENDENCY]: {
        status: 400,
        description: 'O id da aba de configuração do usuário não pode ser o mesmo que o id da aba de origem de dados',
        data: ['tab_id', 'datasource_id'],
    },
    [ErrorCodes.USER_CREDITOR_ID_REQUIRED]: {
        status: 400,
        description: 'O id do credor do usuário não pode ser nulo',
        data: ['tab_id', 'datasource_id'],
    },
    [ErrorCodes.USER_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba de usuário não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.USER_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de usuário não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.USER_RESULT_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de resultado do usuário não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.USER_TAB_ALREADY_EXISTS]: {
        status: 400,
        description: 'A aba de usuário já existe',
        data: ['tab_id'],
    },
};
const planVariablesErrors = {
    [ErrorCodes.PLAN_VARIABLE_NOT_FOUND]: {
        status: 404,
        description: 'Variável de plano não encontrada',
        data: ['tab_id', 'plan_variable'],
    },
    [ErrorCodes.PLAN_NOT_FOUND]: {
        status: 404,
        description: 'Plano não encontrado',
        data: ['plan_id'],
    },
};
const pullV2Errors = {
    [ErrorCodes.PULL_V2_BLOCKED_IN_FDD]: {
        status: 400,
        description: 'Aba puxada não permitida para fontes de dados',
        data: ['tab_id'],
    },
    [ErrorCodes.PULL_V2_UNIFIED_TAB_LIMIT]: {
        status: 400,
        description: 'Permitido puxar apenas uma aba por configuração',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.PULL_V2_UNIFIED_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba puxada não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.OPERATION_BLOCKED_IN_NON_SOURCES_V2]: {
        status: 400,
        description: 'Operação não permitida fora de fontes v2',
        data: ['tab_id', 'column_id'],
    },
};
const pullErrors = {
    [ErrorCodes.PULLED_TAB_NOT_FOUND]: {
        status: 400,
        description: 'Aba puxada não encontrada',
        data: ['tab_id'],
    },
    [ErrorCodes.PULLED_TAB_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna puxada da aba filtrada não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.PULLED_TAB_FILTER_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de filtro da aba puxada não encontrada',
        data: ['tab_id', 'column_id'],
    },
    [ErrorCodes.PULLED_TAB_RESULT_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de resultado não encontrada',
        data: ['tab_id', 'column_id'],
    },
};
const webhookErrors = {
    [ErrorCodes.WEBHOOK_NOT_ALLOWED_ON_PLAN]: {
        status: 400,
        description: 'Fonte de dados do webhook não permitida no plano de comissão',
        data: [],
    },
    [ErrorCodes.WEBHOOK_TAB_NOT_FOUND]: {
        status: 200,
        description: 'Aba não encontrada',
        data: [],
    },
    [ErrorCodes.WEBHOOK_DATASOURCE_NOT_FOUND]: {
        status: 200,
        description: 'Tipo de webhook da fonte de dados não encontrado',
        data: [],
    },
    [ErrorCodes.WEBHOOK_BASIC_AUTH_IS_REQUIRED]: {
        status: 200,
        description: 'Autenticação básica é necessária, autorização não encontrada ou incorreta',
        data: [],
    },
    [ErrorCodes.WEBHOOK_INVALID_CREDENTIALS]: {
        status: 200,
        description: 'Credenciais inválidas',
        data: [],
    },
};
const scheduleErrors = {
    [ErrorCodes.SCHEDULE_JOB_LOCK_ALREADY_EXISTS]: {
        status: 200,
        description: 'Já existe um trabalho em andamento',
        data: ['office_id', 'commission_plan_ids'],
    },
};
const cronErrors = {
    [ErrorCodes.MISSING_FIELD_ON_EXPRESSION]: {
        status: 400,
        description: 'Campos ausentes na expressão cron, obrigatório ter 5 campos',
        data: ['receivend_length'],
    },
    [ErrorCodes.MINUTE_VALUE_NOT_ALLOWED]: {
        status: 400,
        description: 'Arg de minuto inválido',
        data: ['allowed_values'],
    },
    [ErrorCodes.MONTH_VALUE_NOT_ALLOWED]: {
        status: 400,
        description: 'Arg de mês inválido',
        data: ['allowed_values'],
    },
    [ErrorCodes.INVALID_CRON_EXPRESSION]: {
        status: 400,
        description: 'A expressão deve ser uma expressão cron válida',
        data: [],
    },
};
const jobErrors = {
    [ErrorCodes.JOB_NOT_FOUND]: {
        status: 404,
        description: 'Trabalho não encontrado',
        data: ['office_id'],
    },
    [ErrorCodes.JOB_NOT_FOUND_ON_SCHEDULER]: {
        status: 202,
        description: 'Trabalho não encontrado',
        data: ['office_id'],
    },
};
const datasetErrors = {
    [ErrorCodes.DATASET_NOT_FOUND]: {
        status: 404,
        description: 'Conjunto de dados não encontrado',
        data: [],
    },
    [ErrorCodes.BIG_QUERY_FIELD_COLUMN_NOT_FOUND]: {
        status: 404,
        description: 'Coluna do campo Big Query não encontrada',
        data: ['field_name'],
    },
    [ErrorCodes.BIG_QUERY_UPDATED_AT_COLUMN_NOT_FOUND]: {
        status: 400,
        description: 'Coluna de updated_at do Big Query não encontrada',
        data: ['field_name'],
    },
    [ErrorCodes.BIG_QUERY_INVALID_UPDATED_AT_COLUMN_TYPE]: {
        status: 400,
        description: 'A coluna updated_at deve ser DATE | DATETIME | TIMESTAMP',
        data: ['field_name', 'type'],
    },
    [ErrorCodes.BIG_QUERY_CANNOT_UPDATE]: {
        status: 400,
        description: 'Big Query não pode ser atualizado',
        data: ['datasource_id'],
    },
    [ErrorCodes.BIG_QUERY_INSIDE_PLAN_REQUIRE_MATCHES]: {
        status: 400,
        description: 'Big Query dentro do plano requer correspondências',
        data: ['datasource_id'],
    },
    [ErrorCodes.BIG_QUERY_COLUMNS_LOCKED]: {
        status: 400,
        description: 'Dataset_id, table_id e primaryKey do Big Query não podem ser atualizados',
        data: ['datasource_id'],
    },
    [ErrorCodes.BIG_QUERY_CYCLIC_DEPENDENCY]: {
        status: 400,
        description: 'A tab_id de filtro do Big Query não pode ser a mesma que a tab_id da fonte de dados',
        data: ['datasource_id'],
    },
};
const manualErrors = {
    [ErrorCodes.MISSMATCH_COLUMN_QTD]: {
        status: 400,
        description: 'Colunas de linha incompatíveis com o esquema da aba',
        data: ['datasource_id', 'tab_id'],
    },
    [ErrorCodes.INVALID_BATCH_SIZE]: {
        status: 400,
        description: 'O tamanho do lote atual é maior que o limite de tamanho do lote',
        data: ['datasource_id', 'tab_id', 'office_id'],
    },
    [ErrorCodes.MAX_ROW_EXCEDED]: {
        status: 400,
        description: 'Limite máximo de linhas excedido',
        data: ['datasource_id', 'tab_id', 'office_id'],
    },
};
const payrollErrors = {
    [ErrorCodes.PAYROLL_DATA_NOT_FOUND]: {
        status: 404,
        description: 'Dados de folha de pagamento não encontrados',
        data: ['office_id', 'payout_date', 'validate_syncing'],
    },
    [ErrorCodes.SOME_PLAN_IS_SYNCING]: {
        status: 400,
        description: 'Algum plano está sincronizando durante a consulta da folha de pagamento',
        data: ['office_id', 'payout_date'],
    },
};
const migrationErrors = {
    [ErrorCodes.MIGRATION_NOT_ALLOWED]: {
        status: 400,
        description: 'Migração não permitida',
        data: ['message'],
    },
    [ErrorCodes.ALLOWED_ONLY_CALC_ON_BQ]: {
        status: 400,
        description: 'Ação só é permitida com o cálculo no bigquery',
        data: ['message'],
    },
};
const documentSignerErrors = {
    [ErrorCodes.SIGNER_NOT_FOUND]: {
        status: 404,
        description: 'Signer não encontrado',
        data: ['packet_id', 'signer_id', 'creditor_id'],
    },
    [ErrorCodes.DOCUMENT_NOT_FOUND]: {
        status: 404,
        description: 'Document não encontrado',
        data: ['document_id'],
    },
    [ErrorCodes.DOCUMENT_NOT_PENDING_PREPARE_DATA]: {
        status: 202,
        description: 'O documento não está no status de preparação de dados pendente',
        data: ['document_id', 'status', 'external_id'],
    },
    [ErrorCodes.PACKET_NOT_FOUND]: {
        status: 404,
        description: 'O pacote de assinaturas não foi encontrado',
        data: ['packet_id'],
    },
    [ErrorCodes.PACKET_NOT_PENDING]: {
        status: 202,
        description: 'O pacote de assinaturas não está no status pendente',
        data: ['packet_id', 'status', 'external_id'],
    },
};
const inquiryErrors = {
    [ErrorCodes.INQUIRY_CREATION_OVERDUE]: {
        status: 400,
        description: 'Prazo para criação de novo chamado expirado',
        data: ['creditor_id', 'period_id'],
    },
};
exports.Errors = {
    ...jobErrors,
    ...genericErrors,
    ...payoutPlanErrors,
    ...userErrors,
    ...commissionPlanErrors,
    ...tabErrors,
    ...spreadsheetErrors,
    ...datasourceErrors,
    ...groupByErrors,
    ...sumIfErrors,
    ...taskErrors,
    ...joinErrors,
    ...formulaErrors,
    ...sftpErrors,
    ...s3Errors,
    ...procvErrors,
    ...filterErrors,
    ...pullErrors,
    ...pullV2Errors,
    ...planVariablesErrors,
    ...unionErrors,
    ...webhookErrors,
    ...cronErrors,
    ...scheduleErrors,
    ...datasetErrors,
    ...manualErrors,
    ...statementErrors,
    ...unionV2Errors,
    ...historicalErrors,
    ...paymentErrors,
    ...payrollErrors,
    ...dynamicTableErrors,
    ...migrationErrors,
    ...documentSignerErrors,
    ...inquiryErrors,
};
